 import { Component, OnInit, Input } from '@angular/core';
  import { ApiService } from '../api.service';
  import { Observable } from 'rxjs';
  import { Inject, Injectable } from '@angular/core';
  import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
  import { HttpClient } from '@angular/common/http';
  import { User } from '../User';
  import { AlertService } from '../alert.service';
 
    
  @Component({
   selector: 'app-userprofile',
   templateUrl: './userprofile.component.html',
   styleUrls: ['./userprofile.component.scss'],
  })
 
  export class UserprofileComponent implements OnInit {
    
   private user: User = new User();
   emailAdd: String = "";
   addresss: String = "";
   mobileNumber: String = "";
   public showMsg;
  
   
  
 
   custData: Observable<any>;
   city = 1;
   state = 1;
   
   public detail: any = [];
   public getDetail: any = [];
   public getCompDetail: any = [];
  
   
   deliveryType = 0;
   constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
   private httpClient: HttpClient, private alertService: AlertService) {
  
  }
   ngOnInit() {
   this.initCustData();
  }
  
  
  
  
   initCustData() {
   if (this.apiService.checkUserLoggedIn() == true) {
   let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
   this.httpClient.get(urrr)
  .subscribe(
   data => this.intilizeComponent(data),
   error => this.showError(error)
  );
  
  } else {
   console.log("User Not Logged In. Please login!")
  }
  
  }
  
   intilizeComponent(data) {
   this.user = data;
   this.getReferralPoints();
  }
  
   showError(msg) {
   console.log("Error Found in server");
  }
  
  
  
   isEmptyObject(obj) {
   return (obj && (Object.keys(obj).length === 0));
  }
  
  
   updateMobileNumber(mobileNumber) {
   if (this.apiService.checkUserLoggedIn() == true) {
   let postData = { 'mobile': mobileNumber, 'id': this.user.id, 'type': 'mobile', 'oldMobile': this.user.mobile }
   this.httpClient.post(this.apiService.profileUpdateURL, postData)
  .subscribe(
  (detail: any) => {
   //console.log("data is" + detail)
   if (detail.status == true) {
   console.log("otp sent to the number");
   this.initCustData();
  } else {
   console.log("PLease retry some error occured");
  }
  },
   error => this.Error1(error)
  )
  } else { console.log("Please login"); }
  }
  
   Error1(msg) {
   this.alertService.warn("this email address is already exist");
  }
  
   editEmail: string
   updateEmailAddress(emailAdd) {
   if (emailAdd != null) {
   if (this.apiService.checkUserLoggedIn() == true) {
   let postData = { 'email': emailAdd, 'id': this.user.id, 'type': 'email', 'oldEmail': this.user.email }
   this.httpClient.post(this.apiService.profileUpdateURL, postData)
  .subscribe(
  (detail: any) => {
   this.user = detail;
   this.initCustData()
  },
   error => this.Error1(error)
  )
  } else {
   console.log("Please login");
  }
  }
   else {
   console.log("please add email address");
  }
  }
  
  
   updateUserAddress(addressUsr, pincodeUsr , cityUsr, stateUsr) {
   if (this.apiService.checkUserLoggedIn() == true) {
   let addUpdateURL = this.apiService.cutomerDetails + this.user.id;
   let postData = { 'address': addressUsr, 'pinCode': pincodeUsr, 'city': cityUsr, 'state': stateUsr }
   this.httpClient.post(addUpdateURL, postData)
  .subscribe(
  (detail: any) => {
   this.user = detail;
  }
  )
  } else {
   console.log("User not logged in .");
  }
  
  }
  
  
   //otp: number
   verifyOtpN(otpToVerify) {
   //otpToVerify = this.otp;
   let postData = { 'mobile': this.user.mobile, 'otp': otpToVerify }
   this.httpClient.post(this.apiService.verifyOTP_URL, postData)
  .subscribe(
  (detail: any) => {
   console.log("data is" + detail)
   if (detail.status == true) {
   console.log("Success")
   this.showMsg="OTP Verified"
   return true;
  } else {
    this.showMsg="Incorrect OTP"
   return false;
  }
  }
  )
  }
  
  
   resendOtpN() {
   ///resendOtp
   let postData = { 'mobile': this.user.mobile };
   this.httpClient.post(this.apiService.resendURL, postData)
  .subscribe(
  (detail: any) => {
   console.log("data is" + detail)
   if (detail.status == true) {
   return true;
  } else {
   return false;
  }
  }
  )
  }
  getrefDetail:string;
  private points="";
  getReferralPoints()
    {
      let getRefpoint = {"id":this.user.id}
       this.httpClient.post(this.apiService.referralURL, getRefpoint)
       .subscribe(
         (refdetail:any) =>{
           console.log("data4 is" + refdetail)
           this.getrefDetail = refdetail;
           this.points=refdetail.points;
         }
       )
    }
  }
  


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/userprofile/userprofile.component.ts